import { createVanIconComponent } from "./van"

const Star = createVanIconComponent("star")
export default Star
